import { render } from "./TituloGrande.vue?vue&type=template&id=408975a4&scoped=true"
import script from "./TituloGrande.vue?vue&type=script&lang=js"
export * from "./TituloGrande.vue?vue&type=script&lang=js"

import "./TituloGrande.vue?vue&type=style&index=0&id=408975a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408975a4"]])

export default __exports__